export default {
  currencySymbol: '₡',
  table: {
    principal: 'Saldo Cuenta Principal',
    bonus: 'Saldo Cuenta Bono',
    promotional: 'Saldo Cuenta Claro'
  }
}
